[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 3,
                "y": 2,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 12,
                "y": 2,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 12,
                "y": 8,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 3,
                "y": 8,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    }
]